import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
// import PreviewQuestionsModal from '../modals/previewQuestionsModal';

const DOWNLOAD_WINDOW_CLOSE_DELAY = 5000;

const DOWNLOAD_WINDOW_HTML = `
<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>Preparing download</title>
    <style>
      @font-face {
        font-family: "Somatic Rounded";
        src: local("Somatic Rounded");
      }

      * {
        box-sizing: border-box;
      }

      body {
        min-height: 100vh;
        margin: 0;
        display: grid;
        place-items: center;
        background:
          radial-gradient(circle at top left, rgba(105, 93, 255, 0.16), transparent 34rem),
          linear-gradient(135deg, #f7f8fc 0%, #eef2f8 100%);
        color: #1f2937;
        font-family: "Somatic Rounded", Arial, sans-serif;
      }

      main {
        width: min(420px, calc(100vw - 32px));
        padding: 32px;
        border: 1px solid rgba(105, 93, 255, 0.12);
        border-radius: 20px;
        background: rgba(255, 255, 255, 0.92);
        box-shadow: 0 22px 60px rgba(39, 52, 83, 0.14);
        text-align: center;
      }

      .icon {
        width: 56px;
        height: 56px;
        margin: 0 auto 18px;
        display: grid;
        place-items: center;
        border-radius: 50%;
        background: #695dff;
        color: #ffffff;
        box-shadow: 0 14px 28px rgba(105, 93, 255, 0.28);
      }

      .icon svg {
        width: 28px;
        height: 28px;
      }

      h1 {
        margin: 0;
        color: #1d2440;
        font-size: 24px;
        line-height: 1.2;
      }

      p {
        margin: 12px 0 0;
        color: #566074;
        font-size: 15px;
        line-height: 1.55;
      }

      .progress {
        height: 10px;
        margin-top: 24px;
        overflow: hidden;
        border-radius: 999px;
        background: #edf0f7;
      }

      .progress span {
        display: block;
        width: 45%;
        height: 100%;
        border-radius: inherit;
        background: linear-gradient(90deg, #695dff, #8f86ff);
        animation: loading 1.2s ease-in-out infinite;
      }

      .manual-link {
        display: none;
        margin-top: 22px;
        color: #695dff;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-decoration: none;
        text-transform: uppercase;
      }

      .manual-link:hover {
        text-decoration: underline;
      }

      iframe {
        display: none;
      }

      @keyframes loading {
        0% {
          transform: translateX(-100%);
        }

        100% {
          transform: translateX(230%);
        }
      }
    </style>
  </head>
  <body>
    <main>
      <div class="icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M12 3v11m0 0 4-4m-4 4-4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 17v1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <h1>Preparing your resume</h1>
      <p id="download-status">Your download will begin automatically. This tab will close once it has been triggered.</p>
      <div class="progress" aria-hidden="true"><span></span></div>
      <a id="manual-download-link" class="manual-link" href="#" target="_blank" rel="noopener noreferrer">Download manually</a>
    </main>
  </body>
</html>`;

const prepareDownloadWindow = (downloadWindow) => {
  if (!downloadWindow) {
    return;
  }

  downloadWindow.opener = null;
  downloadWindow.document.open();
  downloadWindow.document.write(DOWNLOAD_WINDOW_HTML);
  downloadWindow.document.close();
};

const startDownloadInWindow = (downloadWindow, fileUrl) => {
  if (!downloadWindow) {
    window.location.assign(fileUrl);
    return;
  }

  const downloadDocument = downloadWindow.document;
  const manualDownloadLink = downloadDocument.getElementById('manual-download-link');
  const downloadStatus = downloadDocument.getElementById('download-status');
  const downloadFrame = downloadDocument.createElement('iframe');

  if (manualDownloadLink) {
    manualDownloadLink.href = fileUrl;
    manualDownloadLink.style.display = 'inline-flex';
  }

  if (downloadStatus) {
    downloadStatus.textContent = 'Download started. This tab will close automatically.';
  }

  downloadFrame.title = 'Resume download';
  downloadFrame.src = fileUrl;
  downloadDocument.body.appendChild(downloadFrame);

  downloadWindow.setTimeout(() => {
    downloadWindow.close();
  }, DOWNLOAD_WINDOW_CLOSE_DELAY);
};

export default function ConfirmCard(props) {
  const {
    selectedTemplate,
    selectedResume,
    handlePreviousStepClick,
    getPreview,
    previewLoading,
    preview,
    handlePreviewQuestionsChange,
    questions
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState(null);
  // const [questionsModalState, setQuestionsModalState] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  const handleDownloadFile = async () => {
    const downloadWindow = window.open('', '_blank');

    prepareDownloadWindow(downloadWindow);

    setIsLoading(true);
    try {
      const response = await fetch(`${apiUrl}/formatter/download`, {
        method: "POST",
        headers: {
          "x-api-key": `${apiKey}`,
          "Content-Type": "application/json",
        },
        mode: 'cors',
        body: JSON.stringify({
          "resumeID": selectedResume.id,
          "templateID": selectedTemplate.id,
        })
      });

      if (response.ok) {
        const data = await response.json();
        const fileUrl = data.data.data.url;

        setDownloadUrl(fileUrl);

        startDownloadInWindow(downloadWindow, fileUrl);
      } else {
        if (downloadWindow) {
          downloadWindow.close();
        }
        console.error(`File download failed with status: ${response.status}`);
      }
    } catch (error) {
      if (downloadWindow) {
        downloadWindow.close();
      }
      console.error('File download failed:', error);
    } finally {
      setIsLoading(false);
    }
  }

  const copyToClipboard = () => {
    if (downloadUrl != null) {
      navigator.clipboard.writeText(downloadUrl)
        .then(() => {
          alert('Text copied to clipboard!');
        })
        .catch(err => {
          console.error('Failed to copy: ', err);
        });
    }
  };

  // const handleTogglePreviewQuestionsModal = () => {
  //   setQuestionsModalState(!questionsModalState);
  // };

  return (
    <section style={{ height: '420px', width: '100%' }}>
      <div className="confirm" style={{ maxHeight: '420px', height: '100%' }}>
        <Row fluid="true" className="justify-content-center" style={{ height: '160px', alignItems: 'center', display: 'flex' }}>
          <Col className="px-0" style={{ height: '80px', alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
            {isLoading === true && <div className="spinner-div"><div class="lds-dual-ring"></div></div>}
          </Col>
        </Row>
        {/* <Row>
          <Col fluid="true" className="justify-content-center" style={{ height: '100px', display: 'flex', alignItems: 'center' }}>
            <button className="button" target="_blank"
              onClick={handleTogglePreviewQuestionsModal}>Answer Cover Page Fields</button>
          </Col>
        </Row> */}
        <Col fluid="true" className="justify-content-center">
          <Col className="px-0" style={{ justifyContent: 'space-evenly', display: 'flex', flexDirection: 'column' }}>
            <Col fluid="true" className="justify-content-center" style={{ height: '100px', display: 'flex', alignItems: 'center' }}>
              <button className="button" download="Resume" target="_blank"
                onClick={handleDownloadFile}>Download Resume</button>
            </Col>
            <Col fluid="true" className="justify-content-center" >
              {downloadUrl != null &&
                <div className="link-container">
                  <p className="link-text">Can't see your file? Copy the link below and paste into your browser</p>
                  <button className="button" onClick={copyToClipboard}>Copy Download Link</button>
                </div>}
            </Col>
          </Col>
        </Col>

        {/* {questionsModalState && (
          <PreviewQuestionsModal
            handleTogglePreviewQuestionsModal={handleTogglePreviewQuestionsModal}
            selectedTemplate={selectedTemplate}
            questionsModalState={questionsModalState}
            selectedResume={selectedResume}
            getPreview={getPreview}
            previewLoading={previewLoading}
            preview={preview}
            handlePreviewQuestionsChange={handlePreviewQuestionsChange}
            questions={questions}
          />
        )} */}
      </div>
    </section >
  )
}
